import { ShopService } from '../../../shop/service/shop.service';
import { Component, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldConfig } from '../../../../utils/dynamic-form/form.type';
import { ProductService } from '../../service/product.service';
import { Router } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { UserService } from '../../../user/services/user.service';
import { TippyDirective } from '@ngneat/helipopper';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CategoryService } from '../../../import/service/category.service';
import { ProductQueryParamsData, ProductQueryService } from '../../model/product-query-params';
import { ChannelService } from '../../../import/service/channel.service';
import { StatusService } from '../../service/status.service';
import { ImageModule } from 'primeng/image';
import { BadgeModule } from 'primeng/badge';


import { ProductHelper } from '../../product/helper/productHelper';
import { Shop } from '../../../shop/types/shop.type';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Util } from '../../../../utils/util';
import { Product } from '../../model/product.type';
import { ProductListEditComponent } from '../product-list-edit/product-list-edit.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Message } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-seller-products',
  standalone: true,
  imports: [
    FormsModule,
    CardModule,
    TableModule,
    ButtonModule,
    TagModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    CommonModule,
    TippyDirective,
    ImageModule,
    BadgeModule,
    TranslateModule,
    AutoCompleteModule,
    Message,
    TooltipModule
],
  templateUrl: './seller-product-list.component.html',
  styleUrl: './seller-product-list.component.scss',
  providers: [DialogService, DatePipe, TranslateService],
})
export class SellerProductListComponent implements OnInit {
  tags: any[] = [];
  form: FormGroup;
  filters = [];
  user;
  products: Product[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  totalSelectedProducts: number = 0;

  headers = ProductHelper.productSellerHeaders;
  fields: FieldConfig[] = ProductHelper.searchFilters;

  ref: DynamicDialogRef | undefined;
  appliedFilters = {};
  categories = [];
  categoriesFull = [];
  sellers = [];
  brands = [];
  //productQueryParams: ProductQueryParams = new ProductQueryParams();

  shops: Shop[] = [];
  channels: any = [];
  searchFilters: any = {};

  selectedShop: Shop;
  locales: any = [];
  selectedLocale: any;
  selectedProducts: any[];
  selectAll = false;
  facets;
  isShopDropdownDisabled = true
  constructor(
    private readonly productService: ProductService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly dialogService: DialogService,
    private readonly categoryService: CategoryService,
    private readonly channelService: ChannelService,
    private readonly statusService: StatusService,
    private readonly shopService: ShopService,
    private readonly translate: TranslateService,
    private readonly productQueryParamsService: ProductQueryService
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    this.shops = this.user?.relatedShops;
    this.productQueryParamsService.shopName = this.shopService.getSelectedShop().shopName;
    this.productQueryParamsService.shopCode = this.shopService.getSelectedShop().shopCode;
    this.productQueryParamsService.channel = this.shopService.getSelectedShop().shopChannel.channelCode;
    this.productQueryParamsService.email = this.user?.email;
    this.searchFilters = this.productQueryParamsService.filters
    this.tags = this.productQueryParamsService.tags;
    this.appliedFilters = this.productQueryParamsService.appliedFilters

    const code = this.shopService.getSelectedShopCode();
    this.selectedShop = this.shops.find((shop) => shop.shopCode === code);
    this.channelService.setSelectedChannel(this.selectedShop.shopChannel);
    const searchValue = this.productQueryParamsService.searchKeyWord
    let elements = typeof searchValue === 'string' ? searchValue.trim().split(/\s+/) : [];
    elements = elements.filter(str => str.trim() !== '')
    this.form = new FormGroup({
      shop: new FormControl(this.selectedShop),
      locale: new FormControl(this.selectedLocale),
      search: new FormControl(elements.length > 0 ? elements : ''),
    });
    if (this.shops.length === 1) {
      this.form.get('shop')?.disable(); // Disable the dropdown
    } else {
      this.form.get('shop')?.enable(); // Enable the dropdown
    }
    this.initLocales(this.shopService.getSelectedShop().shopChannel);
    this.initProducts();
  }

  getProductList(data: ProductQueryParamsData) {
    this.loading = true;
    this.productService.getSellerProductList(data).subscribe({
      next: (res) => {
        this.products = res['products'];
        this.loading = false;
        this.totalRecords = res['totalRecords'];
        this.facets = res['facets']
        this.initBrands(res);
      },
    });
  }

  initBrands(data) {
    this.brands = data['facets']['brands'].map((brand) => {
      return { name: brand, key: brand };
    });
  }

  initCategories() {
    if (this.categoriesFull.length === 0) {
      this.categoryService.getCategories().subscribe({
        next: (res) => {
          this.categoriesFull = structuredClone(res);
          this.categories = this.categoryService.getCaterogyByLocale(this.categoriesFull, this.selectedLocale);
        },
      });
    } else {
      this.categories = this.categoryService.getCaterogyByLocale(this.categoriesFull, this.selectedLocale);
    }
  }

  rowClick(event: MouseEvent, product) {
    if (globalThis.getSelection()?.toString()) {
      event.preventDefault();
      return;
    }
    this.router.navigate(['/seller/catalog/' + product.id]);
  }

  loadProducts(event: TableLazyLoadEvent) {
    this.removeSelection();
    let orderDirection = '';
    if (event.sortOrder === 1) {
      orderDirection = 'asc';
    } else if (event.sortOrder === 0) {
      orderDirection = 'desc';
    }
    const currentPage = event.first / event.rows;
    this.productQueryParamsService.pagination = {
      offset: currentPage,
      orderColumn: event.sortField,
      pageSize: event.rows,
      orderDirection: orderDirection
    };
    this.searchProducts();
  }

  searchProducts() {
    this.productQueryParamsService.channel ??= this.shopService.getSelectedShop().shopChannel.channelCode;
    this.productQueryParamsService.email = this.user?.email;
    this.productQueryParamsService.locale = this.selectedLocale;

    if ( Object.keys(this.searchFilters).length != 0) {
      this.productQueryParamsService.addParams(this.searchFilters);
    }

    if ( Object.keys(this.appliedFilters).length != 0) {
      this.productQueryParamsService.appliedFilters = this.appliedFilters;
    }

    if(this.tags.length > 0) {
      this.productQueryParamsService.tags = this.tags;
    }
    if (this.productQueryParamsService.email) {
      this.getProductList(this.productQueryParamsService.get());
    }
  }

  filterGlobal(event, type = null) {
    if (type == 'shop') {
      this.shopService.setSelectedShopCode(event.shopCode);
      this.shopService.setSelectedShop(event)
      this.channelService.setSelectedChannel(event.shopChannel);
      this.productQueryParamsService.channel = event?.shopChannel.channelCode;
      this.productQueryParamsService.shopName = event?.shopName;
      this.productQueryParamsService.shopCode = event?.shopCode;
      this.initLocales(event?.shopChannel);
    } else if (type == 'input') {
      this.productQueryParamsService.searchKeyWord = this.form.get('search')?.value.join(' ').replaceAll('\t', '');
      this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null});
    }

  }

  pasteEvent(filter: any) {
    Util.pasteEvent(this.form, filter);
  }

  onFilterKeydown(event: KeyboardEvent, filter: any) {
    const control = this.form.get(filter.name);
    if (event.key === 'Enter') {
      // l'AutoComplete a déjà ajouté le token; on vide le champ (bug PrimeNG en mode multiple)
      (event.target as HTMLInputElement).value = '';
      return;
    }
    Util.addTokenOnSeparatorKey(event, control);
  }

  onFilterPaste(event: ClipboardEvent, filter: any) {
    const control = this.form.get(filter.name);
    if (Util.pasteTokens(event, control)) {
      this.filterGlobal(null, 'input');
    }
  }

  initFilters() {
    this.filters = [
      {
        type: 'statusTree',
        name: 'status',
        header: 'filters.status',
        values: this.statusService.getStatus(),
      },
      {
        type: 'categoryTree',
        name: 'category',
        header: 'filters.category',
        values: this.categories,
      },
      {
        type: 'select',
        search: true,
        name: 'brands',
        key: 'name',
        header: 'filters.brand',
        values: this.brands,
      },
      {
        type: 'date',
        name: 'lastImportDate',
        header: 'filters.lastImport',
      },
    ];
  }


  openFilterModal() {
    Util.openFilterModal(
      this.dialogService,
      this.translate,
      this,
      this.initFilters,
      this.loadProducts
    );
  }

  resetFilters() {
    this.productQueryParamsService.resetFilters()
    this.productQueryParamsService.appliedFilters = {};
    this.productQueryParamsService.tags = []
    Util.resetFilters(this, this.loadProducts);
  }
  removeFilter(value, parent) {
    this.tags = this.tags.filter((tag) => tag.name !== value);
    delete this.searchFilters[value];
    if (parent) {
      this.appliedFilters[parent] = this.appliedFilters[parent].filter((filter) => filter.group !== value);
      if (this.appliedFilters[parent].length === 0) {
        delete this.appliedFilters[parent];
      }
    } else {
      delete this.appliedFilters[value];
    }
    this.productQueryParamsService.resetFilters()
    this.productQueryParamsService.appliedFilters = this.appliedFilters;
    this.productQueryParamsService.tags = this.tags
    this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null});
  }

  initProducts(): any {
    if (this.channels.length === 0) {
      this.channelService.getChannels().subscribe((res: any) => {
        this.channels = res;
        this.selectedLocale ??= this.channelService.getSelectedLocale();
        this.productQueryParamsService.locale = this.selectedLocale;
        this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null });
      });
    } else {
      this.selectedLocale ??= this.channelService.getSelectedLocale();
      this.productQueryParamsService.locale = this.selectedLocale;
      this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null });
    }
  }

  getRowClass(product, header) {
    let classes = '';
    classes +=
      ' ' + product?.editorialCharter?.status === 'Modification requise ' && header.id === 'editorialCharter '
        ? 'highlight-background-modification '
        : '';
    classes +=
      ' ' + product?.editorialCharter?.status === 'En attente de vérification ' && header.id === 'editorialCharter '
        ? 'highlight-background-verification '
        : '';
    classes += (header.id === 'label' || header.id === 'category') ? 'underline-text' : '';

    return classes;
  }

  getSeverity(status: string) {
    return Util.getSeverity(status);
  }

  isPublicationStatusErrors(product) {
    return product?.publicationStatusErrors.length > 0 ? product?.publicationStatusErrors[0].message != "" : false;
  }
  getSeverityForPublicationStatus(product) {
    return Util.getSeverityForPublicationStatus(product?.status, this.isPublicationStatusErrors(product));
  }
  
  getPublicationStatusErrors(product) {
    return product?.publicationStatusErrors
            .map((error) => Util.buildMessage('-', error, ['level', 'attributeCode', 'message']) )
  }

  getColumnMinWidth(id: string): string {
    switch (id) {
      case 'product':
        return '100px';
      case 'label':
        return '200px';
      case 'editorialCharter':
        return '150px';
      default:
        return 'auto';
    }
  }

  initLocales(channel = null) {
    let selectedChannel = this.selectedShop?.shopChannel;
    if (channel) {
      selectedChannel = channel;
    }
     this.selectedLocale = this.channelService.getDefaultLocal(
      this.productQueryParamsService.channel,
      this.channels,
    )
    this.channelService.getLocales(selectedChannel).subscribe({
      next: (res: any) => {
        this.locales = res.locales;
        this.selectedLocale ??= this.productQueryParamsService.locale ?? this.locales?.[0];

        this.productQueryParamsService.locale = this.selectedLocale;
        this.channelService.setSelectedLocale(this.selectedLocale);
        this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null});
        this.initCategories();
      },
    });
  }

  updateLocale(event) {
    this.selectedLocale = event;
    this.channelService.setSelectedLocale(event);
    this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null });
  }


  selectAllProducs() {
    this.selectAll = true;
    if (this.totalRecords > 50000) {
      this.totalSelectedProducts = 50000;
    } else {
      this.totalSelectedProducts = this.totalRecords;
    }
    this.selectedProducts = structuredClone(this.products);
  }

  removeSelection() {
    this.selectedProducts = [];
    this.selectAll = false;
  }

  openEditProductsDialog() {
    let totalSelected = this.selectedProducts.length;
    let categs = this.selectedProducts.map(p => p.category)
    let differentCategories = new Set(categs);
    if(this.selectAll) {
      totalSelected = this.totalRecords;
      differentCategories = this.facets.categories?.length;
    }
    const data = {
      totalSelected: totalSelected,
      differentCategories: differentCategories.size,
      categories: this.categories
    }
    this.ref = this.dialogService.open(ProductListEditComponent, {
      header: this.translate.instant('shop.updateCategoryAndAttributes'),
      data: data,
      width: '30vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '1200px': '50vw',
        '960px': '60vw',
        '640px': '80vw',
      },
    });
    this.ref.onClose.subscribe({
      next: (data) => {
        if (data) {
            console.log(data)
        }
      },
    });
   }

  onSelectionChange(event) {
    this.selectedProducts = event;
    this.selectAll = false;
  }

  exportProducts() {
    let data = {};
    if(this.productQueryParamsService.get().pagination?.orderColumn) {
      data['orderColumn'] = this.productQueryParamsService.get().pagination?.orderColumn;
      data['orderDirection'] = this.productQueryParamsService.get().pagination?.orderDirection;
    }
    if (this.selectAll) {
        Object.assign(data, this.productQueryParamsService.getExport());
    } else {
      data['ids'] = this.selectedProducts.map((product) => product.productId);
    }


  }

  
  resetSearch() {
    this.form.get(this.fields[1].name).reset();
    this.productQueryParamsService.searchKeyWord = "";
    this.loadProducts({ first: 0, rows: 100, sortField: null, sortOrder: null});
  }
}
